import React from "react";
import { StatusBadge } from "@/components/common/StatusBadge";
import { EmptyState } from "@/components/common/EmptyState";
import { formatDate, formatDateShort } from "@/lib/format";
import { MessageSquare, ArrowRight, Clock, CalendarClock, User } from "lucide-react";

export const FollowUpTimeline = ({ followUps }) => {
  if (!followUps?.length) {
    return (
      <EmptyState icon={MessageSquare} title="No follow-ups yet"
        description="Add your first discussion note to build the timeline." />
    );
  }
  return (
    <div className="relative space-y-4 pl-2">
      <div className="absolute bottom-2 left-[13px] top-2 w-px bg-border" />
      {followUps.map((f, i) => (
        <div key={f.id} className="relative flex gap-3">
          <span className={`relative z-10 mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full ring-4 ring-background ${i === 0 ? "bg-brand text-brand-foreground" : "bg-secondary text-muted-foreground"}`}>
            <MessageSquare className="h-3 w-3" />
          </span>
          <div className="min-w-0 flex-1 rounded-xl border border-border bg-card p-3 shadow-card">
            <div className="flex flex-wrap items-center gap-2">
              <span className="text-xs font-semibold text-foreground">{formatDate(f.created_at)}</span>
              {f.follow_up_time && <span className="inline-flex items-center gap-1 text-[11px] text-muted-foreground"><Clock className="h-3 w-3" /> {f.follow_up_time}</span>}
              {f.status && <StatusBadge status={f.status} size="sm" />}
              {i === 0 && <span className="ml-auto rounded-full bg-brand/10 px-2 py-0.5 text-[10px] font-bold text-brand">Latest</span>}
            </div>
            {f.discussion_note && <p className="mt-1.5 text-sm text-foreground">{f.discussion_note}</p>}
            {f.next_action && (
              <p className="mt-1.5 inline-flex items-center gap-1 rounded-md bg-accent px-2 py-1 text-xs font-medium text-accent-foreground">
                <ArrowRight className="h-3 w-3" /> {f.next_action}
              </p>
            )}
            <div className="mt-2 flex items-center gap-3 text-[11px] text-muted-foreground">
              {f.created_by_name && <span className="inline-flex items-center gap-1"><User className="h-3 w-3" /> {f.created_by_name}</span>}
              {f.reminder_date && <span className="inline-flex items-center gap-1"><CalendarClock className="h-3 w-3" /> Next: {formatDateShort(`${f.reminder_date}T00:00:00`)}</span>}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
